"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Purchases: () => Purchases
});
module.exports = __toCommonJS(index_native_exports);
var import_validateCallback = require("../validateCallback");
var import_react_native = require("react-native");
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_unavailable = require("./unavailable");
var hybrid;
function native() {
  if (import_react_native.Platform.OS !== "ios") throw new Error("Purchases requires an iOS native build");
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OnePurchases");
  return hybrid;
}
function getProducts(productIds) {
  return native().getProducts(productIds).catch(import_nativeError.rethrowNativeError);
}
function purchase(productId, appAccountToken) {
  return native().purchase(productId, appAccountToken).catch(import_nativeError.rethrowNativeError);
}
function getCurrentEntitlements() {
  return native().getCurrentEntitlements().catch(import_nativeError.rethrowNativeError);
}
function getUnfinishedTransactions() {
  return native().getUnfinishedTransactions().catch(import_nativeError.rethrowNativeError);
}
function finishTransaction(transactionId) {
  return native().finishTransaction(transactionId).catch(import_nativeError.rethrowNativeError);
}
function addTransactionListener(onUpdate) {
  (0, import_validateCallback.validateCallback)(onUpdate, "Purchases.addTransactionListener requires a function");
  return native().addTransactionListener(onUpdate);
}
function sync() {
  return native().sync().catch(import_nativeError.rethrowNativeError);
}
var nativePurchases = Object.freeze({
  getProducts,
  purchase,
  getCurrentEntitlements,
  getUnfinishedTransactions,
  finishTransaction,
  addTransactionListener,
  sync
});
var Purchases = import_react_native.Platform.OS === "android" ? import_unavailable.Purchases : nativePurchases;
//# sourceMappingURL=index.native.js.map
